import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useFilterSettings } from '@perxis-auto/instock-sdk/lib/features/filterChoice';
import { useAppSelector } from '@perxis-auto/instock-sdk/lib/shared/lib/store';
import { selectors as configSelectors } from '@perxis-auto/instock-sdk/lib/shared/store/config';
import { usePageReady } from '@perxis-auto/instock-sdk/lib/shared/store/installation';
import { EventService } from '@perxis-auto/shared';

import { AppConstructor } from '@/app/appConstructor';
import { APP, APP_EVENTS } from '@/shared/config';
import { PAGES } from '@/shared/config/pages';
import { SEO } from '@/shared/ui/seo';

import { CarsProps } from './Cars.types';

export function Cars(props: CarsProps) {
  const layouts = useAppSelector(configSelectors.selectLayout);
  const location = useLocation();

  const layout = layouts?.[PAGES.Cars];

  const [isScrolled, setIsScrolled] = useState(false);

  const handleLoadedCars = useCallback(() => {
    if (!isScrolled && location.state && location.state.lastPage === PAGES.Car && location.pathname === PAGES.Cars) {
      window.requestAnimationFrame(() => {
        document.documentElement.scrollTo({
          top: Number(sessionStorage.getItem(`${APP.sdk}/scroll`)) || 0,
        });
        setIsScrolled(true);
        sessionStorage.removeItem(`${APP.sdk}/scroll`);
      });
    }
  }, [isScrolled, location.pathname, location.state]);

  useEffect(() => {
    handleLoadedCars();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageReady = useCallback(() => {
    EventService.getInstance().sendEvent(APP_EVENTS.CarsPageVisited);
  }, []);

  useFilterSettings();

  usePageReady({
    onReady: handlePageReady,
  });

  if (!layout) {
    return null;
  }

  return (
    <>
      <SEO title="Страница списка авто" />
      <AppConstructor layout={layout!} />
    </>
  );
}
